/** 이 이름으로 ClickHouse `otel_traces` 의 SpanName 에 쌓인다. */
export const WEB_VITAL_LOG_NAME = 'quiz_web_vital';

/** 프로덕션은 브라우저 세션의 10% 만 보낸다. 페이지뷰당 최대 5건이라 전수는 과하다. */
export const PRODUCTION_SAMPLE_RATE = 0.1;

const SAMPLED_STORAGE_KEY = 'zep_web_vitals_sampled';

export interface WebVitalMetric {
  name: string;
  value: number;
  rating?: string;
  navigationType?: string;
  id: string;
}

/** 페이지 수명 동안 한 번 확정되는 지표만 보낸다. Next 커스텀 지표(`Next.js-*`)는 라우트 전환마다 나와 제외한다. */
const REPORTED_METRICS = new Set(['TTFB', 'FCP', 'LCP', 'FID', 'INP', 'CLS']);

export const isReportedMetric = (name: string) => REPORTED_METRICS.has(name);

/** 탭 단위로 한 번 정하고 유지한다 — 같은 세션의 지표가 일부만 빠지지 않게. */
export const isSampledSession = (
  storage: Pick<Storage, 'getItem' | 'setItem'> | undefined,
  sampleRate: number,
  random: () => number = Math.random,
): boolean => {
  try {
    const saved = storage?.getItem(SAMPLED_STORAGE_KEY);
    if (saved === '1' || saved === '0') return saved === '1';

    const sampled = random() < sampleRate;
    storage?.setItem(SAMPLED_STORAGE_KEY, sampled ? '1' : '0');
    return sampled;
  } catch {
    // 쓰기 차단·quota 0 등. 저장 없이 매번 뽑는다(그 브라우저군이 통째로 빠지지 않게).
    return random() < sampleRate;
  }
};

export interface WebVitalContext {
  /** 문서에 처음 들어온 라우트 패턴. CLS·INP·LCP 는 문서 수명 동안 집계돼 늦게 확정된다. */
  route: string;
  effectiveType: string | undefined;
}

/** 국가·CDN·버킷(eks/vercel)·커밋은 로거 공통 상태에 이미 있어 여기선 싣지 않는다. */
export const buildWebVitalAttributes = (
  metric: WebVitalMetric,
  { route, effectiveType }: WebVitalContext,
) => ({
  metric_name: metric.name,
  // CLS 는 점수라 소수점을 남기고, 나머지는 ms 라 정수로 충분하다.
  metric_value:
    metric.name === 'CLS'
      ? Math.round(metric.value * 1000) / 1000
      : Math.round(metric.value),
  metric_rating: metric.rating ?? 'unknown',
  navigation_type: metric.navigationType ?? 'unknown',
  metric_id: metric.id,
  route,
  effective_type: effectiveType ?? 'unknown',
});
